import { travel } from '@assets/icons'
import ActiveBookings from '@commons/bookings/active'
import Table from '@components/table'
import React from 'react'

const UserActiveBookings = ({ user }) => {
  return <ActiveBookings user={user} />
}

export default UserActiveBookings
